module.exports = __webpack_public_path__ + "media/assets/4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/4.svg
// module id = 15
// module chunks = 0